/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, ResendWebhookLog } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateResendWebhookLog(options?: Omit<(UseMutationOptions<(ResendWebhookLog | undefined), DefaultError, Prisma.ResendWebhookLogCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendWebhookLogCreateArgs, DefaultError, ResendWebhookLog, true>('ResendWebhookLog', 'POST', `${endpoint}/resendWebhookLog/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendWebhookLogCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendWebhookLogCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ResendWebhookLog, Prisma.ResendWebhookLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ResendWebhookLogCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ResendWebhookLog, Prisma.ResendWebhookLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyResendWebhookLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ResendWebhookLogCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendWebhookLogCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('ResendWebhookLog', 'POST', `${endpoint}/resendWebhookLog/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendWebhookLogCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendWebhookLogCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ResendWebhookLogCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyResendWebhookLog<TArgs extends Prisma.ResendWebhookLogFindManyArgs, TQueryFnData = Array<Prisma.ResendWebhookLogGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/findMany`, args, options, fetch);
}

export function useInfiniteFindManyResendWebhookLog<TArgs extends Prisma.ResendWebhookLogFindManyArgs, TQueryFnData = Array<Prisma.ResendWebhookLogGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/findMany`, args, options, fetch);
}

export function useSuspenseFindManyResendWebhookLog<TArgs extends Prisma.ResendWebhookLogFindManyArgs, TQueryFnData = Array<Prisma.ResendWebhookLogGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyResendWebhookLog<TArgs extends Prisma.ResendWebhookLogFindManyArgs, TQueryFnData = Array<Prisma.ResendWebhookLogGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/findMany`, args, options, fetch);
}

export function useFindUniqueResendWebhookLog<TArgs extends Prisma.ResendWebhookLogFindUniqueArgs, TQueryFnData = Prisma.ResendWebhookLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueResendWebhookLog<TArgs extends Prisma.ResendWebhookLogFindUniqueArgs, TQueryFnData = Prisma.ResendWebhookLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/findUnique`, args, options, fetch);
}

export function useFindFirstResendWebhookLog<TArgs extends Prisma.ResendWebhookLogFindFirstArgs, TQueryFnData = Prisma.ResendWebhookLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstResendWebhookLog<TArgs extends Prisma.ResendWebhookLogFindFirstArgs, TQueryFnData = Prisma.ResendWebhookLogGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/findFirst`, args, options, fetch);
}

export function useUpdateResendWebhookLog(options?: Omit<(UseMutationOptions<(ResendWebhookLog | undefined), DefaultError, Prisma.ResendWebhookLogUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendWebhookLogUpdateArgs, DefaultError, ResendWebhookLog, true>('ResendWebhookLog', 'PUT', `${endpoint}/resendWebhookLog/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendWebhookLogUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendWebhookLogUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ResendWebhookLog, Prisma.ResendWebhookLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ResendWebhookLogUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ResendWebhookLog, Prisma.ResendWebhookLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyResendWebhookLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ResendWebhookLogUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendWebhookLogUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('ResendWebhookLog', 'PUT', `${endpoint}/resendWebhookLog/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendWebhookLogUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendWebhookLogUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ResendWebhookLogUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertResendWebhookLog(options?: Omit<(UseMutationOptions<(ResendWebhookLog | undefined), DefaultError, Prisma.ResendWebhookLogUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendWebhookLogUpsertArgs, DefaultError, ResendWebhookLog, true>('ResendWebhookLog', 'POST', `${endpoint}/resendWebhookLog/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendWebhookLogUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendWebhookLogUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ResendWebhookLog, Prisma.ResendWebhookLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ResendWebhookLogUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ResendWebhookLog, Prisma.ResendWebhookLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteResendWebhookLog(options?: Omit<(UseMutationOptions<(ResendWebhookLog | undefined), DefaultError, Prisma.ResendWebhookLogDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendWebhookLogDeleteArgs, DefaultError, ResendWebhookLog, true>('ResendWebhookLog', 'DELETE', `${endpoint}/resendWebhookLog/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendWebhookLogDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendWebhookLogDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, ResendWebhookLog, Prisma.ResendWebhookLogGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.ResendWebhookLogDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, ResendWebhookLog, Prisma.ResendWebhookLogGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyResendWebhookLog(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.ResendWebhookLogDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.ResendWebhookLogDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('ResendWebhookLog', 'DELETE', `${endpoint}/resendWebhookLog/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.ResendWebhookLogDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.ResendWebhookLogDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.ResendWebhookLogDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateResendWebhookLog<TArgs extends Prisma.ResendWebhookLogAggregateArgs, TQueryFnData = Prisma.GetResendWebhookLogAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateResendWebhookLog<TArgs extends Prisma.ResendWebhookLogAggregateArgs, TQueryFnData = Prisma.GetResendWebhookLogAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/aggregate`, args, options, fetch);
}

export function useGroupByResendWebhookLog<TArgs extends Prisma.ResendWebhookLogGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.ResendWebhookLogGroupByArgs['orderBy'] } : { orderBy?: Prisma.ResendWebhookLogGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.ResendWebhookLogGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.ResendWebhookLogGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.ResendWebhookLogGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.ResendWebhookLogGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.ResendWebhookLogGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByResendWebhookLog<TArgs extends Prisma.ResendWebhookLogGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.ResendWebhookLogGroupByArgs['orderBy'] } : { orderBy?: Prisma.ResendWebhookLogGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.ResendWebhookLogGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.ResendWebhookLogGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.ResendWebhookLogGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.ResendWebhookLogGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.ResendWebhookLogGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/groupBy`, args, options, fetch);
}

export function useCountResendWebhookLog<TArgs extends Prisma.ResendWebhookLogCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.ResendWebhookLogCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/count`, args, options, fetch);
}

export function useSuspenseCountResendWebhookLog<TArgs extends Prisma.ResendWebhookLogCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.ResendWebhookLogCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.ResendWebhookLogCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/count`, args, options, fetch);
}

export function useCheckResendWebhookLog<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; eventType?: string; messageId?: string; signatureValid?: boolean; signatureReceived?: string; signatureExpected?: string }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('ResendWebhookLog', `${endpoint}/resendWebhookLog/check`, args, options, fetch);
}
